import { Navigate } from 'react-router-dom';
import { ROUTES } from '@shared/config';

/** Старый адрес загрузки лонглиста ведёт в мастер на шаг лонглиста. */
export function LegacyImportRedirect() {
  return <Navigate to={`${ROUTES.ESTIMATE_NEW}?source=longlist`} replace />;
}
